// Multiple API keys to rotate and avoid quota limits
const API_KEYS = [
  process.env.REACT_APP_YOUTUBE_API_KEY,
  process.env.REACT_APP_YOUTUBE_API_KEY_1,
  process.env.REACT_APP_YOUTUBE_API_KEY_2,
  process.env.REACT_APP_YOUTUBE_API_KEY_3,
].filter(key => key); // Remove undefined keys

const YOUTUBE_API_URL = 'https://www.googleapis.com/youtube/v3/search';

// Simple key rotation
let currentKeyIndex = 0;

const getNextApiKey = () => {
  if (API_KEYS.length === 0) return null;
  const key = API_KEYS[currentKeyIndex];
  currentKeyIndex = (currentKeyIndex + 1) % API_KEYS.length;
  return key;
};

export const searchYouTubeVideos = async (query, maxResults = 10) => {
  if (API_KEYS.length === 0) {
    // No API keys available
    return [];
  }

  // Try each API key until one works
  for (let attempt = 0; attempt < API_KEYS.length; attempt++) {
    const apiKey = getNextApiKey();
    
    try {
      const response = await fetch(
        `${YOUTUBE_API_URL}?part=snippet&q=${encodeURIComponent(query)}&maxResults=${maxResults}&type=video&key=${apiKey}`
      );
      
      if (response.ok) {
        const data = await response.json();
        if (!data.items) {
          return [];
        }
        return data.items.map((item) => ({
          id: item.id.videoId,
          type: 'youtube_video',
          title: item.snippet.title,
          description: item.snippet.description || '',
          thumbnail: item.snippet.thumbnails.medium.url,
          videoURL: `https://www.youtube.com/watch?v=${item.id.videoId}`,
          uploadDate: new Date(item.snippet.publishedAt),
          channelMobile: item.snippet.channelTitle,
          category: 'YouTube',
        }));
      } else {
        const errorText = await response.text();
        // If quota exceeded, try next key
        if (errorText.includes('quota')) {
          continue; // Try next API key
        }
        // For other errors, return empty
        return [];
      }
    } catch (error) {
      // Try next API key on any error
      continue;
    }
  }
  
  // All API keys failed
  return [];
};
